export class ButtonHelper {
    static initSpinnerButtons(): void {
        document.addEventListener('click', (e) => {
            const btn = (e.target as HTMLElement).closest('.db-button');
            if (!btn) return;

            const spinner = btn.querySelector('.spinner-icon');
            if (!spinner) return;

            // Add loading class
            btn.classList.add('loading');

            // Hide chevrons
            btn.querySelectorAll('.fa-chevron-right, .fa-chevron-left').forEach(icon => {
                (icon as HTMLElement).style.display = 'none';
            });
        });
    }

    /**
     * Resets spinner buttons
     * - If `id` is provided, only that button is reset
     * - If not, all spinner buttons are reset
     */
    static resetSpinnerButtons(id?: string): void {
        // Short delay to ensure DOM updates have been applied
        setTimeout(() => {
            let buttons: NodeListOf<Element>;

            if (id) {
                const btn = document.getElementById(id);
                if (!btn) return;
                buttons = [btn] as any;
            } else {
                buttons = document.querySelectorAll('.db-button.loading');
            }

            if (buttons.length === 0) {
                console.warn('resetSpinnerButtons: No loading buttons found.');
                return;
            }

            buttons.forEach(btn => {
                btn.classList.remove('loading');

                // Restore chevrons
                btn.querySelectorAll('.fa-chevron-right, .fa-chevron-left').forEach(icon => {
                    (icon as HTMLElement).style.display = '';
                });
            });
        }, 50);
    }
}